export const FragmentMessages = Object.freeze({
    FB_FIELD_POSITION:
        "Enter Zone or Team followed by the yardline to select field position e.g. H35, B35 | V35, C35",
    FB_TEAM_FIELD_POSITION:
        "Enter Team followed by the yardline to select field position e.g. H35 | V35"
});
